import { Component, Input } from '@angular/core';
import { ButtonWidget } from '../../models/button-widget';
import { Observable } from 'rxjs';

@Component({
  selector: 'mojo-overview-items-container',
  templateUrl: './overview-items-container.component.html'
})
export class OverviewItemsContainerComponent {

  @Input()
  items$: Observable<Array<ButtonWidget>>;

}
